import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import DataListContainer from './DataListContainer';
import Utils from '../../utils';
import instances from './instances';
import autoRefresh from '../autoRefresh';
import cacheStrategy from '../cacheStrategy';
/**
 * @extends {React.Component<import('data/types').DataListProps>}
 */

var DataList =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DataList, _React$Component);

  function DataList() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DataList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DataList)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.loadData = function (options) {
      var _this$props = _this.props,
          dataType = _this$props.dataType,
          dataProps = _this$props.dataProps;
      if (_this.actions) return _this.actions.fetch(_objectSpread({
        dataType: dataType,
        dataProps: dataProps
      }, options));
    };

    _this.renderChildren = function (_ref) {
      var state = _ref.state,
          actions = _ref.actions;
      _this.actions = actions;
      return _this.props.children({
        state: state,
        actions: actions
      });
    };

    return _this;
  }

  _createClass(DataList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      instances.register(this.props.id, this);
      var id = this.props.id;
      if (typeof id === 'undefined') throw new Error('DataList requires an id prop');
      cacheStrategy(this.props, this.loadData);
      this.autoRefresh = autoRefresh(this.props, this.loadData);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!Utils.deepEqual(this.props.dataProps, prevProps.dataProps)) this.loadData();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      instances.unregister(this.props.id);
      this.autoRefresh.stop();
    }
  }, {
    key: "refresh",
    value: function refresh() {
      var _this$props2 = this.props,
          dataType = _this$props2.dataType,
          dataProps = _this$props2.dataProps;
      if (this.actions) this.actions.fetch({
        dataType: dataType,
        dataProps: dataProps
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          rest = _objectWithoutProperties(_this$props3, ["children"]);

      return React.createElement(DataListContainer, rest, this.renderChildren);
    }
  }]);

  return DataList;
}(React.Component);

DataList.defaultProps = {
  cacheStrategy: 'cache-first',
  refreshInterval: Infinity
};
export default DataList;